import { useEffect } from 'react';

/**
 * SEO Component for dynamic meta tags per route
 * Compatible with React 19
 */
const SEO = ({ 
  title = 'Donate Your Body | Alternative to Donating Your Body to Science | MASS BODY',
  description = 'MASS BODY is a legally structured body donation program offering an alternative to donating your body to science, focused on ecological art, decomposition, and environmental continuity.',
  image = 'https://massbody.org/003white_transparent_cropped.png',
  url = 'https://massbody.org',
  type = 'website'
}) => {
  useEffect(() => {
    // Update document title
    document.title = title;

    // Helper function to update or create meta tag
    const updateMetaTag = (property, content) => {
      let element = document.querySelector(`meta[${property}]`);
      if (!element) {
        element = document.createElement('meta');
        const isProperty = property.startsWith('property=');
        if (isProperty) {
          element.setAttribute('property', property.replace('property=', '').replace(/['"]/g, ''));
        } else {
          element.setAttribute('name', property.replace('name=', '').replace(/['"]/g, ''));
        }
        document.head.appendChild(element);
      }
      element.setAttribute('content', content);
    };

    // Update or create meta tags
    updateMetaTag('name="description"', description);
    updateMetaTag('property="og:title"', title);
    updateMetaTag('property="og:description"', description);
    updateMetaTag('property="og:image"', image);
    updateMetaTag('property="og:url"', url);
    updateMetaTag('property="og:type"', type);
    updateMetaTag('name="twitter:title"', title);
    updateMetaTag('name="twitter:description"', description);
    updateMetaTag('name="twitter:image"', image);
    updateMetaTag('name="twitter:url"', url);

    // Update canonical link
    let canonicalLink = document.querySelector('link[rel="canonical"]');
    if (!canonicalLink) {
      canonicalLink = document.createElement('link');
      canonicalLink.setAttribute('rel', 'canonical');
      document.head.appendChild(canonicalLink);
    }
    canonicalLink.setAttribute('href', url);

  }, [title, description, image, url, type]);

  return null; // This component doesn't render anything
};

export default SEO;
